module.exports = __webpack_public_path__ + "img/support.f58cd0d5.svg";